module.exports = __webpack_public_path__ + "img/IMG_8924.1d85b358.jpg";